import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStaffAuth } from '../../../contexts/StaffAuthContext';
import Layout from '../../../components/shared/Layout/Layout';
import Button from '../../../components/shared/Button/Button';
import {
  AuthContainer,
  AuthCard,
  AuthTitle,
  AuthSubtitle,
  AuthFooter,
  FormGroup,
  FormLabel,
  FormInput,
  ErrorMessage,
} from '../../../components/shared/Form/Form.styles';

const StaffLogin = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { login, isAuthenticated, loading, sessionNotice } = useStaffAuth();
  const navigate = useNavigate();

  // Si ya hay una sesión de staff válida, directo al escáner.
  useEffect(() => {
    if (!loading && isAuthenticated) navigate('/staff/scanner', { replace: true });
  }, [loading, isAuthenticated, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const result = await login(formData.email.trim(), formData.password);

    if (result.success) {
      navigate('/staff/scanner');
    } else {
      setError(result.error || 'Error al iniciar sesión');
    }
    setSubmitting(false);
  };

  const notice = error || sessionNotice;

  return (
    <Layout headerType="staff">
      <AuthContainer>
        <AuthCard>
          <AuthTitle>Acceso del equipo</AuthTitle>
          <AuthSubtitle>
            Entra con el correo y la contraseña que te dio tu empresa para escanear QRs.
          </AuthSubtitle>

          {notice && <ErrorMessage role="alert">{notice}</ErrorMessage>}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel htmlFor="staff-email">Email</FormLabel>
              <FormInput
                id="staff-email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="tu@correo.com"
                autoComplete="username"
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel htmlFor="staff-password">Contraseña</FormLabel>
              <FormInput
                id="staff-password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Tu contraseña"
                autoComplete="current-password"
                required
              />
            </FormGroup>

            <Button type="submit" fullWidth disabled={submitting}>
              {submitting ? 'Iniciando sesión...' : 'Entrar'}
            </Button>
          </form>

          <AuthFooter>
            <p>¿Eres el dueño del negocio? <Link to="/empresa/login">Entra al portal de empresa</Link></p>
          </AuthFooter>
        </AuthCard>
      </AuthContainer>
    </Layout>
  );
};

export default StaffLogin;
